import React from 'react';
//Components
import moment from 'moment';
import MissedProductSalesOptions from './missedProductSalesOptions.jsx';
import MissedProductSalesSummary from './missedProductSalesSummary.jsx';
import Loader from 'components/loader';
import {connectToPOSPermissions, POS_PERMISSIONS} from 'helpers/posPermissions';

import ReportApi from 'api/report';
import {FormattedMessage} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

const tableMaxRows = 20;

class MissedProductSales extends React.Component {
  state = {
    data: [],
    filters: [],
    loaded: true,
    showNoDataMessage: false,
  };

  componentWillMount() {
    let date = new Date();
    let filters = {
      dateFrom: moment(new Date(date.setMonth(date.getMonth() - 1))),
      dateTo: moment(new Date()),
      branch: 0,
      categoryType: 0,
    };

    this.setState({
      filters: filters,
    });
  }

  onPageChange = page => {
    const {count, fullReport} = this.state;
    const pagReport = fullReport.slice((page - 1) * count, count * page);

    this.setState({
      data: pagReport,
      page: page,
    });
  };

  updateReportData = (dateFrom, dateTo, branch, categoryType) => {
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      branch: branch,
      categoryType: categoryType,
    };

    this.setState({loaded: false});
    ReportApi.getMissedProductSalesReport(dateFrom, dateTo, branch, categoryType)
      .then(data => {
        if (data) {
          data.forEach(row => {
            row.Volume = Math.max(0, row.VolumeRecomended - row.VolumePurchased) + ' ' + row.Unit;
            row.VolumePurchased = row.VolumePurchased + ' ' + row.Unit;
            row.VolumeRecomended = row.VolumeRecomended + ' ' + row.Unit;
          });
          this.setState({
            count: tableMaxRows,
            data: data.slice(0, tableMaxRows),
            filters: filters,
            fullReport: data,
            loaded: true,
            page: 1,
            showNoDataMessage: false,
            total: data.length,
          });
        }
        if (!Object.keys(data).length) {
          this.setState({showNoDataMessage: true});
        }
      }).catch(e => {
        console.log(e);
        this.setState({loaded: true, showNoDataMessage: true});
      });
  };

  render() {
    const {filters, data, page, count, total, showNoDataMessage, fullReport} = this.state;

    return <div className="report-container">
      <span>
        <FormattedMessage id="reports.missed.products.description"/>
      </span>
      <MissedProductSalesOptions updateReportData={this.updateReportData}
                                 branches={this.props.branchesInfo}
                                 branchesIds={this.props.branches}
                                 defaultFilters={this.state.filters}/>
      <Loader loaded={this.state.loaded}>
        <MissedProductSalesSummary report={data}
                                   fullReport={fullReport}
                                   filters={filters}
                                   onPageChange={this.onPageChange}
                                   page={page}
                                   count={count}
                                   total={total}
                                   showNoDataMessage={showNoDataMessage}/>
      </Loader>
    </div>;
  }
}

export default connectToPOSPermissions(POS_PERMISSIONS.DETAILED_REPORTING)(MissedProductSales);
